import { Sparkles, Lock } from "lucide-react";
import { people } from "../../data/demoContent";

export const AIHubContent = ({ consent }) =>
  consent ? (
    <div className="flex h-full flex-col items-center justify-center text-center" data-testid="ai-hub-found">
      <span className="flex -space-x-2">
        <img src={people.karna.avatar} alt="Karna" className="h-10 w-10 rounded-full border-2 border-white object-cover" />
        <img src={people.shashin.avatar} alt="Shashin" className="h-10 w-10 rounded-full border-2 border-white object-cover" />
      </span>
      <span className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#7866E8]">
        <Sparkles size={12} aria-hidden /> AI intelligence
      </span>
      <p className="mt-1 text-[17px] font-bold leading-tight tracking-[-0.02em] text-[#08090D]">AI found a meaningful moment.</p>
    </div>
  ) : (
    <div className="flex h-full flex-col items-center justify-center text-center" data-testid="ai-hub-blocked">
      <span className="grid h-10 w-10 place-items-center rounded-full bg-[#08090D] text-white"><Lock size={16} aria-hidden /></span>
      <p className="mt-3 text-[16px] font-bold leading-tight text-[#08090D]">No suggestion.</p>
      <p className="mt-1 text-[12px] text-[#5b5f73]">Consent is missing.</p>
    </div>
  );

export const AIHubPending = () => (
  <div className="flex h-full flex-col items-center justify-center text-center">
    <span className="h-2 w-2 rounded-full bg-[#A79DE2]" aria-hidden />
    <p className="mt-3 text-[13px] font-medium text-[#5b5f73]">Listening for opt-in signals</p>
  </div>
);
